module.exports = __webpack_public_path__ + "img/unionPay.7f843806.svg";